/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Unfavorite_SuccessInputs */



/**
* | output |
* | --- |
* | "Project removed from favorites." |
*
* @param {Project_Unfavorite_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_unfavorite_success = /** @type {((inputs?: Project_Unfavorite_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Unfavorite_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt aus Favoriten entfernt.")
	return /** @type {LocalizedString} */ ("Project removed from favorites.")
});